import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import { MDBContainer, MDBIcon, MDBInput } from 'mdb-react-ui-kit'
import MDB4Datatable from '../../content/MDB4Datatable/MDB4Datatable.component'
import { toast } from 'react-toastify'
import moment from 'moment'
import { Subscription, BehaviorSubject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import MessageService from './../../../shared/services/Message.service'
import PaginationControls from './../../../components/content/PaginationControls/PaginationControls.component'
// import PaginationComponent from adminShared/Pagination.component'
import { makeAutoObservable } from 'mobx'
import { MessageFactory } from './../../../shared/factories'
import Store from './../Messaging.store'

import './MessagesList.scss'

const today = moment().startOf('day'),
  lastDate = moment(new Date()).subtract(7, 'days').endOf('day'),
  timezoneOffset = new Date().getTimezoneOffset()

const MessagesList = ({ category, division_id }) => {
  category = category === 'leaders' ? 'leader' : category
  category = category === 'messages' ? 'dashboard' : category

  const { fetchMessagesByCategory, Messages, pagination } = Store

  const formatRows = Msgs => {
    return (Msgs || []).map(Msg => {
      const title = Msg.get('title'),
        category = Msg.get('category'),
        updated_at = Msg.get('updated_at'),
        id = Msg.id(),
        start_date = Msg.get('start_date'),
        end_date = Msg.get('end_date'),
        deleted_at = Msg.get('deleted_at')

      const editBtn = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div
              className={'cursor-pointer d-inline-block'}
              role={'button'}
              onClick={() => (Store.Message[category] = Msg)}
            >
              <MDBIcon icon={deleted_at ? 'eye' : 'edit'} size='2x' className='blue-text p-1' />
            </div>
          </div>
        ),
        formatedDate = (
          <span searchvalue={updated_at ? moment(updated_at).format('YYYY/MM/DD') : ''}>
            {updated_at ? moment(updated_at).format('MM/DD/YYYY') : 'N/A'}
          </span>
        ),
        formatedStartDate = (
          <span
            searchvalue={
              start_date
                ? moment(new Date(new Date(start_date).getTime() + timezoneOffset * 60000)).format('YYYY/MM/DD')
                : ''
            }
          >
            {start_date
              ? moment(new Date(new Date(start_date).getTime() + timezoneOffset * 60000)).format('MM/DD/YYYY')
              : 'N/A'}
          </span>
        ),
        formatedEndDate = (
          <span
            searchvalue={
              end_date
                ? moment(new Date(new Date(end_date).getTime() + timezoneOffset * 60000)).format('YYYY/MM/DD')
                : ''
            }
          >
            {end_date
              ? moment(new Date(new Date(end_date).getTime() + timezoneOffset * 60000)).format('MM/DD/YYYY')
              : 'N/A'}
          </span>
        )

      return {
        title: title,
        updated_at: formatedDate,
        start_date: formatedStartDate,
        end_date: formatedEndDate,
        edit: editBtn,
      }
    })
  }

  useEffect(() => {
    if (category) fetchMessagesByCategory(category, division_id)
  }, [category, division_id])

  const onPageSelect = p => {
    Store.pagination[category] = { ...pagination[category], ...p }
    fetchMessagesByCategory(category, division_id)
  }

  const tableData = {
    columns: [
      {
        label: 'Message Title',
        field: 'title',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'Updated Date',
        field: 'updated_at',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'Start Date',
        field: 'start_date',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'End Date',
        field: 'end_date',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'Edit',
        field: 'edit',
        sort: 'disabled',
        width: 150,
      },
    ],
    rows: formatRows(Store.Messages[category]),
  }

  return (
    <>
      <MDB4Datatable
        data={tableData}
        searching={false}
        paging={false}
        displayEntries={false}
        info={false}
        sortRows={['updated_at', 'start_date', 'end_date']}
        striped
        bordered
        small
        className='text-capitalize'
      />
      {pagination[category]?.total > 0 && (
        <div className='pagination-wrapper'>
          <PaginationControls pagination={pagination[category]} onPageSelect={onPageSelect} />
        </div>
      )}
    </>
  )
}

export default observer(MessagesList)
